import { render, staticRenderFns } from "./FormBuilderModal.vue?vue&type=template&id=24351bd5"
import script from "./FormBuilderModal.vue?vue&type=script&lang=js"
export * from "./FormBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderModal.vue?vue&type=style&index=0&id=24351bd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports